import React from 'react';
import useTranslationLgs from '@hooks/i18n/useTranslation';
import { withAuthenticationRequired } from '@auth0/auth0-react';
import CompanyNotificationList from '@components/features/CompanyNotification/Customer/CompanyNotificationList.tsx';
import ResponsiveLayout from '@app/layout/ResponsiveLayout.tsx';

interface ComponentProps {
}

const CompanyNotificationPage: React.FC<ComponentProps> = () => {
  const { tr } = useTranslationLgs();
  return (
    <ResponsiveLayout title={tr(`CompanyNotificationPage.title`, `Námi rozeslaná upozornění`)}>
      <CompanyNotificationList />
    </ResponsiveLayout>
  );
};

export default withAuthenticationRequired(CompanyNotificationPage);
